import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsTipoPedidoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/tipo-pedido');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Pedido');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/tipo-pedido', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Pedido');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/tipo-pedido', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Tipo Pedido');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/tipo-pedido/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Tipo Pedido');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/tipo-pedido/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Tipo Pedido');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/tipo-pedido/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Pedido');
    }
  }

  async getPerfis(id) {
    try {
      const { data } = await this.api.get(`/tipo-pedido/${id}/perfis`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar os perfis do Tipo de Pedido');
    }
  }

  async setPerfis(id, perfis) {
    try {
      const { data } = await this.api.put(`/tipo-pedido/${id}/perfis`, { perfis });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao salvar os perfis do Tipo de Pedido');
    }
  }
}
